import { http } from 'lib/services/http';
import { prepareResources } from './helpers';
import {
  APP_RESOURCES_REQUEST,
  APP_RESOURCES_SUCCESS,
  APP_RESOURCES_FAILURE,
  APP_ACTIONS_REQUEST,
  APP_ACTIONS_SUCCESS,
  APP_ACTIONS_FAILURE,
  APP_SETTINGS_REQUEST,
  APP_SETTINGS_SUCCESS,
  APP_SETTINGS_FAILURE,
} from './types';

const errorNotificaton = (
  dispatch,
  error,
  type,
  fallbackMessage,
  setSnackbar,
) => {
  setSnackbar({
    message: error.msg || fallbackMessage,
    severity: 'error',
  });
  dispatch({ type, payload: error });

  return Promise.reject(error);
};

export const getResources = (url, headers, setSnackbar) => {
  return (dispatch) => {
    dispatch({ type: APP_RESOURCES_REQUEST });

    return http
      .get(url, headers && { headers })
      .then((response) => response.data)
      .then((response) => prepareResources(response))
      .then((payload) => dispatch({ type: APP_RESOURCES_SUCCESS, payload }))
      .catch((e) =>
        errorNotificaton(
          dispatch,
          e,
          APP_RESOURCES_FAILURE,
          'Could not load resources for selected application!',
          setSnackbar,
        ),
      );
  };
};

export const getActions = (url, headers) => {
  return (dispatch) => {
    dispatch({ type: APP_ACTIONS_REQUEST });

    return http
      .get(url, headers && { headers })
      .then((response) => response.data)
      .then((payload) => dispatch({ type: APP_ACTIONS_SUCCESS, payload }))
      .catch((e) =>
        errorNotificaton(
          dispatch,
          e,
          APP_ACTIONS_FAILURE,
          'Could not load actions for selected application!',
        ),
      );
  };
};

export const getSettings = (url, headers) => {
  return (dispatch) => {
    dispatch({ type: APP_SETTINGS_REQUEST });

    return http
      .get(url, headers && { headers })
      .then((response) => response.data)
      .then((payload) =>
        dispatch({
          type: APP_SETTINGS_SUCCESS,
          payload: payload[0] || payload,
        }),
      )
      .catch((e) =>
        errorNotificaton(
          dispatch,
          e,
          APP_SETTINGS_FAILURE,
          'Could not load settings for selected application!',
        ),
      );
  };
};
